export default "__VITE_ASSET__eDNvz5Bg__"